import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export function getQueryKey(orgId: string | undefined, key: string) {
  if (orgId === undefined || orgId === "") {
    // Programming error. This hook should only be called with a valid orgId.
    throw new Error(
      "Invalid orgId. useOrgConfig must be used with a valid orgId.",
    );
  }
  return ["orgConfig", orgId, key];
}

export function useOrgConfig(orgId: string | undefined, key: string) {
  const { configService } = useDomainServices();

  return useQuery({
    queryKey: getQueryKey(orgId, key),
    queryFn: ({ signal }) => {
      if (orgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }

      return configService.getOrgConfig(orgId, key, {
        abortSignal: signal,
      });
    },
    enabled: orgId !== undefined,
  });
}
